import { mergeAttributes, Node } from '@tiptap/core'
import { SpacerAttributes } from '../interfaces/SpacerAttributes'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    spacer: {
      /**
       * Add a spacer
       */
      setSpacer: (
        options?: Partial<Pick<SpacerAttributes, 'height' | 'backgroundColor'>>,
      ) => ReturnType

      /**
       * Edit spacer attributes
       */
      setSpacerAttributes: (
        options: Omit<Partial<SpacerAttributes>, 'HTMLAttributes'>,
      ) => ReturnType
    }
  }
}

export const Spacer = Node.create<SpacerAttributes>({
  name: 'spacer',
  priority: 1000,
  group: 'block',
  draggable: true,

  addAttributes() {
    return {
      height: {
        default: 20,
        parseHTML: (element) => Number(element.getAttribute('height')),
        renderHTML: (attributes) => {
          return {
            height: attributes.height.toString(),
          }
        },
      },
      backgroundColor: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-background-color'),
        renderHTML: (attributes) => {
          return {
            'data-background-color': attributes.backgroundColor,
          }
        },
      },
    }
  },

  addCommands() {
    return {
      setSpacer:
        (options) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: options || { height: 20 },
          })
        },
      setSpacerAttributes:
        (attributes) =>
        ({ commands }) => {
          return commands.updateAttributes(this.name, attributes)
        },
    }
  },

  renderHTML({ HTMLAttributes, node }) {
    const {
      height,
      backgroundColor,
    }: Omit<Partial<SpacerAttributes>, 'HTMLAttributes'> = node.attrs
    const styles = []
    if (backgroundColor) styles.push(`background-color: ${backgroundColor}`)
    if (height) styles.push(`height: ${height}px`)
    HTMLAttributes.style = styles.join(';')
    return [
      'div',
      mergeAttributes(
        {
          'data-email-component': this.name,
        },
        this.options.HTMLAttributes,
        HTMLAttributes,
        {
          class: 'spacer',
          contenteditable: false,
        },
      ),
    ]
  },

  parseHTML() {
    return [{ tag: `div[data-email-component="${this.name}"]` }]
  },
})
